import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http'
import { AuthHttp } from 'angular2-jwt'
import { Router } from '@angular/router';
import { AlertService } from './alert.service';

import 'rxjs/add/operator/toPromise';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';

@Injectable()
export class HttpService {
    httpFlag: boolean = true;
    constructor(
        private http: AuthHttp,
        private alert: AlertService,
        private router: Router
    ) {
    }


    public get(url: string, params?: any) {
        if (!this.httpFlag) {
            return;
        }
        var urlSearchParams = new URLSearchParams();
        if (typeof (params) == 'object') {
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var element = params[key];
                    if (element instanceof Date) {
                        element = element.toDateString();
                    }
                    urlSearchParams.append(key, element);
                }
            }
        } else if (typeof (params) == 'string') {
            url += '?' + params;
        } else if (params instanceof URLSearchParams) {
            urlSearchParams = params;
        } else {

        }
        return this.http.get(url, { search: urlSearchParams }).toPromise()
            .then(s => s.json())
            .catch(
                (e) => {
                    this.httpFlag = false;
                    // if (e.status == 401) {
                    //     this.handleErr401Fun();

                    //     /* this.alert.confirmAlert('您的身份验证已失效，请重新登录', '认证失败', ['确定'], () => {
                    //         this.handleErr401Fun();
                    //     }, () => {
                    //         this.handleErr401Fun();
                    //     }) */

                    // }
                    // else {
                    //     this.httpFlag = true;
                    //     throw e;
                    // }
                    switch (e.status) {
                        case 401:
                            this.handleErr401Fun();
                            break;
                        case 331:
                            this.router.navigate(['/maintain']);
                            this.httpFlag = true;
                            break;
                        default:
                            this.httpFlag = true;
                            throw e;
                    }
                }
            );
    }
    public post(url: string, body: any, options?: any) {
        if (!this.httpFlag) {
            return;
        }
        return this.http.post(url, body, options)
            .toPromise()
            .then(s => s.json())
            .catch(
                (e) => {
                    this.httpFlag = false;
                    // if (e.status == 401) {
                    //     this.handleErr401Fun();

                    //     /* this.alert.confirmAlert('您的身份验证已失效，请重新登录', '认证失败', ['确定'], () => {
                    //         this.handleErr401Fun();
                    //     }, () => {
                    //         this.handleErr401Fun();
                    //     }) */

                    // } else {
                    //     this.httpFlag = true;
                    //     throw e;
                    // }
                    switch (e.status) {
                        case 401:
                            this.handleErr401Fun();
                            break;
                        case 331:
                            this.router.navigate(['/maintain']);
                            this.httpFlag = true;
                        default:
                            this.httpFlag = true;
                            throw e;
                    }
                }
            );
    }

    handleErr401Fun() {
        localStorage.clear();
        this.router.navigate(['/login']);
        this.httpFlag = true;
        localStorage.setItem('firstLoadHomePic', 'true');
        localStorage.setItem('errEnter', 'true');
    }
    public getWithoutAuth(url: string) {
        return this.http.get(url).toPromise()
            .then(s => s.json());
    }

    public postWithoutAuth(url: string, body: any) {
        return this.http.post(url, body).toPromise()
            .then(s => s.json())
            .catch(this.handleError)
            ;
    }

    private handleError(response: Observable<any>): Observable<any> {
        return response;
        // if(error.status == 401){
        //     this.events.publish('auth:unauthorized');
        //     return Promise.reject(error);
        // }else{
        //     return Promise.reject(error);
        // }
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/http.service.ts